import { Skeleton, Table } from 'antd';
import React, { useEffect, useState } from 'react'
import API from 'API';
import dayjs from "dayjs";
import { formatScore } from 'general_function';

const NOW = dayjs();

function CourseStatus({ course, selectedTerm }) {
    return course.passed ? <span className='test-status done'>
        Đã qua môn
    </span> : selectedTerm.end_time.isBefore(NOW) ? <span className='test-status not-do'>
        Đã trượt
    </span> : <span className='test-status during'>
        Đang học
    </span>
}

export default function ScoreTable({ selectedTerm, user }) {
    const [loading, setLoading] = useState(true);
    const [scoreCourses, setCourseCourses] = useState([]);
    useEffect(() => {
        setLoading(true);
        async function getData() {
            try {
                const response = await API.post("student/get-scores/", {
                    term_id: selectedTerm.id,
                    user: user
                },[])
                for (const c of response.data) {
                    var result = 0;
                    const columns = [];
                    const data = {key: "uni"};
                    for (const score of c.scores) {
                        columns.push({
                            title: `${score.title} (${score.rate}%)`,
                            key: `score_${score.id}`,
                            dataIndex: `score_${score.id}`,
                        })
                        if (score.test_end_time) {
                            score.test_end_time = dayjs(score.test_end_time);
                        }
                        data[`score_${score.id}`] = formatScore(score.score, score.test_end_time);
                        if (score.score) {
                            result += score.score*score.rate/100
                        }
                    }
                    c.columns = columns;
                    c.data = [data];
                    c.status = <CourseStatus course={c} selectedTerm={selectedTerm} />;
                    c.result = formatScore(result);
                }
                setCourseCourses(response.data);
            } catch (e) {
                console.log(e);
            } finally {
                setLoading(false);
            }
        }
        getData();
    },[selectedTerm, user])
    return loading ? <Skeleton active /> : <>
        <Table 
            rowKey="id"
            columns={[
                {title: "Môn học", key: "name", dataIndex: "name"},
                {title: "Trạng thái", key: "status", dataIndex: "status"},
                {title: "Điểm tổng kết", key: "result", dataIndex: "result"},
            ]}
            dataSource={scoreCourses}
            pagination={false}
            expandable={{
                expandedRowRender: record=><Table
                    rowKey={"key"}
                    columns={record.columns}
                    dataSource={record.data}
                    pagination={false}
                />
            }}
        />
    </>
}
